import { EditPolicyActivitiesController } from "../ts/rlAdmin.controllers.config";
import * as Models from "../ts/rlAdmin.models";


RLActivityTreeList.$inject = ["$compile"];
export function RLActivityTreeList($compile: ng.ICompileService) {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/activity-tree-list.html"),
        require: ["rlActivityTreeList", "^ngController"],
        controller: RLActivityTreeListController,
        controllerAs: "atlVM",
        bindToController: true,
        replace: true,
        scope: {
            activities: "=",
            depth: "=",
            parentActivity: "=?"
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: [RLActivityTreeListController, EditPolicyActivitiesController]) => {
            controllers[0].treeCtrl = controllers[1];

        }
    };
    return directive;
}


export class RLActivityTreeListController {

    static $inject = ["$scope"];

    treeCtrl: EditPolicyActivitiesController;
    activities: Models.IAspNetSecurityActivity[];
    parentActivity: Models.IAspNetSecurityActivity;
    depth: number;

    constructor($scope: ng.IScope) {

    }

}
